import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteReviewItem, GetAssetsReviewImage, ReviewAdd, UploadFileModel} from 'src/app/models/review';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ReviewManagementService } from 'src/app/services/review-management.service';

@Component({
  selector: 'app-add-reviews',
  templateUrl: './add-reviews.component.html',
  styleUrls: ['./add-reviews.component.css']
})
export class AddReviewsComponent implements OnInit {

  addReview: ReviewAdd =  new ReviewAdd();
  Loader: boolean = false;
  file: any;
  id: number;
  imageUrl: any;
  getReviewsImgItem: DeleteReviewItem = new DeleteReviewItem();
  uploadFileArray: UploadFileModel = new UploadFileModel();
  getAssetsReviewImage: Array<GetAssetsReviewImage> = new Array<GetAssetsReviewImage>();
  showImageReviewImage: GetAssetsReviewImage = new GetAssetsReviewImage();
  showImageSubmit: boolean = false;
  reviewImageLoader: boolean = false;

  constructor(private alertify: AlertifyService, private _reviewUploadImageService: ReviewManagementService, private routes: ActivatedRoute, private _reviewAddService: ReviewManagementService, private router: Router, public fb: FormBuilder,) { } 
  ngOnInit() {}
  
  
  onSubmit() {
    if (this.addReview.name == undefined || this.addReview.name == null || this.addReview.name == "") {
      this.alertify.error("Review Name is required");
      return;
    }
    if (this.addReview.title == undefined || this.addReview.title == null || this.addReview.title == "") {
      this.alertify.error("Review Title is required");
      return;
    }
    if (this.addReview.comments == undefined || this.addReview.comments == null || this.addReview.comments == "") {
      this.alertify.error("Review  comments is required");
      return;
    }
    this.Loader = true;
    this._reviewAddService.addReviews(this.addReview).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.addReview = responseBody.responseData;
        if (this.uploadFileArray.Image !=undefined)
        {
          this.uploadFile();
        } else {
          this.alertify.success(responseBody.responseMessage);
          this.router.navigate(['reviews-listing']);
          this.Loader = false;
        }
      } else {
        this.alertify.error(responseBody.responseMessage);
        this.Loader = false;
      }
     
    });
  }

  uploadFile() {
    if (this.uploadFileArray.Image.name.toLowerCase().includes('.png') || this.uploadFileArray.Image.name.toLowerCase().includes('.jpg') || this.uploadFileArray.Image.name.toLowerCase().includes('.jpeg')) {
      this.uploadFileArray.Id= this.addReview.id;
      this.showImageSubmit = false;
      this._reviewUploadImageService.uploadImage(this.uploadFileArray)
        .subscribe((rec) => {
          this.router.navigate(['reviews-listing']);
          this.Loader = false;
        });
    } else {
      this.alertify.error("Only files in .jpg, .jpeg, .png format are accepted and directories are not allowed.");
    }
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.file);
    this.uploadFileArray.Image = this.file;
    this.showImageSubmit = true;
  }
}
